import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "../locales/en.json";
import ar from "../locales/ar.json";
import useLocalizationStore from "../store/zustand/localization";
const initI18n = () => {
  const { language } = useLocalizationStore.getState();
  i18n
    // Add React bindings as a plugin.
    .use(initReactI18next)
    // Initialize the i18next instance.
    .init({
      lng: language,
      fallbackLng: "en",
      debug: false,

      interpolation: {
        escapeValue: false,
      },
      resources: {
        en: {
          translation: en,
        },
        ar: {
          translation: ar,
        },
      },
    });
};

export default initI18n;
